export const colors = {
    black: '#000000',
    white: '#FFFFFF',
}
